import { MouseEvent, useState } from 'react'

/**
 * Convenience hook for handling the state for a popover that needs to anchor to a clicked element.
 */
export const usePopover = <T extends HTMLElement>() => {
  const [anchorEl, setAnchorEl] = useState<T | null>(null)

  const handleOpen = (event: MouseEvent<T>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const PopoverProps = { open: !!anchorEl, anchorEl, onClose: handleClose }

  return {
    anchorEl,
    setAnchorEl,
    handleOpen,
    handleClose,
    PopoverProps,
  }
}
